import { render } from "./NavCrumbs.vue?vue&type=template&id=6bca55c5"
import script from "./NavCrumbs.vue?vue&type=script&lang=js"
export * from "./NavCrumbs.vue?vue&type=script&lang=js"

import "./NavCrumbs.vue?vue&type=style&index=0&id=6bca55c5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__